import { InjectionToken, ValueProvider } from '@angular/core';

/**
 * A token used to hook urls to be ignored by the http busy state interceptor.
 * These will be eventually ignored by the global blocking loading animation managed by the `LoadingStateService`.
 *
 * Prefer using {@link provideHttpBusyStateIgnoredUrl} instead of providing this token directly.
 */
export const HTTP_BUSY_STATE_IGNORED_URLS = new InjectionToken<string[]>('__HTTP_BUSY_STATE_IGNORED_URLS__');

/**
 * Creates a strongly-typed provider for the {@link HTTP_BUSY_STATE_IGNORED_URLS} token as it is expected by `HttpBusyStateInterceptor`.
 *
 * @export
 * @param {string} url The url to ignore.
 * @return {*}  {ValueProvider}
 */
export function provideHttpBusyStateIgnoredUrl(url: string): ValueProvider {
    return {
        provide: HTTP_BUSY_STATE_IGNORED_URLS,
        useValue: url,
        multi: true
    } as const;
}
